export default "__VITE_ASSET__B1yyJr_r__"